export default "__VITE_ASSET__69ed799d__$_?component__"